import $ from 'jquery';

const setButtonPlace = () => {
    $('.camp-template-dates-action').each(function () {
        const current = $(this);
        const parent = current.parents('.accordion-item');
        const content = parent.find('.accordion-collapse');

        if (window.matchMedia('(min-width: 576px)').matches) {
            current.appendTo(content);
        } else {
            current.appendTo(parent);
        }
    });
};

$(window).bind('resize', setButtonPlace).trigger('resize');
